<!--
 * @Description: 发票详情弹窗
 * @Author: yeqing
 * @Date: 2021-9-7 17:35:30
 * @LastEditTime:
 * @LastEditors:
-->
<template>
  <a-modal :visible="isVisible" title="查看发票" :footer="null" @cancel="handleCancel" class="bill-detail-model" width="770px">
    <div class="img-box">
      <img :src="invoiceUrl" />
    </div>
    <div class="cr-jc-center">
      <a-button type="primary" class="download-btn" @click="handleDownload"> 下载</a-button>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    invoiceUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleCancel() {
      this.$emit('update:isVisible', false)
    },

    // 下载
    handleDownload() {
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = this.invoiceUrl
      link.setAttribute('download', '发票')
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>

<style lang="less" scoped>
.bill-detail-model {
  .img-box {
    width: 722px;
    height: 351px;
    background: #fcfcfc;
    border: 1px solid #f0f0f0;
    > img {
      width: 722px;
      height: 351px;
    }
  }
  .download-btn {
    margin-top: 14px;
  }
  ::v-deep.ant-btn {
    width: 65px;
    border-radius: 2px;
  }
}
</style>
